import React, {Component} from "react";
import {Routes, Route, Link, Navigate, Outlet} from "react-router-dom";
import history from './history';
import Login from "./activities/Login";
import {isUserAuthenticated} from "./RequestManager";
import Dashboard from "./activities/Dashboard";
import PlanDetails from "./activities/PlanDetails";
import ChoosePlans from "./activities/ChoosePlans";
import Assignment from "./activities/Assignment";
import AssignmentSubmit from "./activities/AssignmentSubmit";
class App extends Component {
    constructor(props) {
        super(props);
        history.listen((location, action) => {
        });
    }
    render() {
        const paths = [
            {path: '/',component: <Dashboard />},
            {path: '/plan',component: <PlanDetails />},
            {path: '/choose-plan',component: <ChoosePlans />},
            {path: '/assignments',component: <Assignment />},
            {path: '/assign-submit/:bookId/:id',component: <AssignmentSubmit />},
         ];
        return (
            <Routes>
                <Route exact path="/login" element={<PublicOutlet />}>
                    <Route path="" element={<Login />}/>
                </Route>
                {paths.map(path =><Route exact path={path?.path} element={<PrivateOutlet />}>
                    <Route path="" element={path?.component}/>
                </Route>)}
            </Routes>
        );
    }
}
function PrivateOutlet() {
    const isLogged = isUserAuthenticated();
    return isLogged ? <Outlet /> : <Navigate to="/login" />;
}
function PublicOutlet() {
    const isLogged = isUserAuthenticated();
    return isLogged ? <Navigate to={'/'} /> : <Outlet />;
}
export default App;
